import { render, staticRenderFns } from "./PartnersSlider.vue?vue&type=template&id=dfc2e076&scoped=true"
import script from "./PartnersSlider.vue?vue&type=script&lang=js"
export * from "./PartnersSlider.vue?vue&type=script&lang=js"
import style0 from "./PartnersSlider.vue?vue&type=style&index=0&id=dfc2e076&prod&lang=scss&scoped=true"
import style1 from "./PartnersSlider.vue?vue&type=style&index=1&id=dfc2e076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc2e076",
  null
  
)

export default component.exports